import { HighLevel } from "./types"

export const highLevel: HighLevel = {
    name: "Christian Coker",
    title: "Designer, Developer",
    intro: "I love crafting digital products and experiences that make a difference in people’s lives.",
}